// extracted by css-extract-rspack-plugin
export default {"root":"root-MKErSL","svg":"svg-Ged_PT","circle":"circle-oBCADc","path":"path-orNJlj"};